/**
 *
 * @param {string} name
 * @returns
 */

const url = `app`;

export const LOAD_EXPENSES_LIST = `${url}/LOAD_EXPENSES_LIST`;
export const LOAD_EXPENSES_LIST_SUCCESS = `${url}/LOAD_EXPENSES_LIST_SUCCESS`;
export const LOAD_EXPENSES_LIST_ERROR = `${url}/LOAD_EXPENSES_LIST_ERROR`;

export const LOAD_PREFIX_SETTINGS_LIST = `${url}/LOAD_PREFIX_SETTINGS_LIST`;
export const LOAD_PREFIX_SETTINGS_LIST_SUCCESS = `${url}/LOAD_PREFIX_SETTINGS_LIST_SUCCESS`;
export const LOAD_PREFIX_SETTINGS_LIST_ERROR = `${url}/LOAD_PREFIX_SETTINGS_LIST_ERROR`;

export const LOAD_FINANCIAL_YEAR_LIST = `${url}/LOAD_FINANCIAL_YEAR_LIST`;
export const LOAD_FINANCIAL_YEAR_LIST_SUCCESS = `${url}/LOAD_FINANCIAL_YEAR_LIST_SUCCESS`;
export const LOAD_FINANCIAL_YEAR_LIST_ERROR = `${url}/LOAD_FINANCIAL_YEAR_LIST_ERROR`;

export const LOAD_EXPENSES_ITEMS_LIST = `${url}/LOAD_EXPENSES_ITEMS_LIST`;
export const LOAD_EXPENSES_ITEMS_LIST_SUCCESS = `${url}/LOAD_EXPENSES_ITEMS_LIST_SUCCESS`;
export const LOAD_EXPENSES_ITEMS_LIST_ERROR = `${url}/LOAD_EXPENSES_ITEMS_LIST_ERROR`;

export const LOAD_EXPENSES_CATEGORIES_LIST = `${url}/LOAD_EXPENSES_CATEGORIES_LIST`;
export const LOAD_EXPENSES_CATEGORIES_LIST_SUCCESS = `${url}/LOAD_EXPENSES_CATEGORIES_LIST_SUCCESS`;
export const LOAD_EXPENSES_CATEGORIES_LIST_ERROR = `${url}/LOAD_EXPENSES_CATEGORIES_LIST_ERROR`;

export const LOAD_EXPENSE_REPORT_LIST = `${url}/LOAD_EXPENSE_REPORT_LIST`;
export const LOAD_EXPENSE_REPORT_LIST_SUCCESS = `${url}/LOAD_EXPENSE_REPORT_LIST_SUCCESS`;
export const LOAD_EXPENSE_REPORT_LIST_ERROR = `${url}/LOAD_EXPENSE_REPORT_LIST_ERROR`;

export const LOAD_CASH_BANK_REPORT_LIST = `${url}/LOAD_CASH_BANK_REPORT_LIST`;
export const LOAD_CASH_BANK_REPORT_LIST_SUCCESS = `${url}/LOAD_CASH_BANK_REPORT_LIST_SUCCESS`;
export const LOAD_CASH_BANK_REPORT_LIST_ERROR = `${url}/LOAD_CASH_BANK_REPORT_LIST_ERROR`;

export const LOAD_EXPENSE_ACCOUNT_TRANSACTION_DETAILS = `${url}/LOAD_EXPENSE_ACCOUNT_TRANSACTION_DETAILS`;
export const LOAD_EXPENSE_ACCOUNT_TRANSACTION_DETAILS_SUCCESS = `${url}/LOAD_EXPENSE_ACCOUNT_TRANSACTION_DETAILS_SUCCESS`;
export const LOAD_EXPENSE_ACCOUNT_TRANSACTION_DETAILS_ERROR = `${url}/LOAD_EXPENSE_ACCOUNT_TRANSACTION_DETAILS_ERROR`;

export const LOAD_CASH_BANK_TOTAL_LIST = `${url}/LOAD_CASH_BANK_TOTAL_LIST`;
export const LOAD_CASH_BANK_TOTAL_LIST_SUCCESS = `${url}/LOAD_CASH_BANK_TOTAL_LIST_SUCCESS`;
export const LOAD_CASH_BANK_TOTAL_LIST_ERROR = `${url}/LOAD_CASH_BANK_TOTAL_LIST_ERROR`;

export const CREATE_EXPENSES_LIST = `${url}/CREATE_EXPENSES_LIST`;
export const CREATE_EXPENSES_LIST_SUCCESS = `${url}/CREATE_EXPENSES_LIST_SUCCESS`;
export const CREATE_EXPENSES_LIST_ERROR = `${url}/CREATE_EXPENSES_LIST_ERROR`;

//category

export const UPDATE_EXPENSES_LIST = `${url}/UPDATE_EXPENSES_LIST`;
export const UPDATE_EXPENSES_LIST_SUCCESS = `${url}/UPDATE_EXPENSES_LIST_SUCCESS`;
export const UPDATE_EXPENSES_LIST_ERROR = `${url}/UPDATE_EXPENSES_LIST_ERROR`;

export const DELETE_EXPENSES_LIST = `${url}/DELETE_EXPENSES_LIST`;
export const DELETE_EXPENSES_LIST_SUCCESS = `${url}/DELETE_EXPENSES_LIST_SUCCESS`;
export const DELETE_EXPENSES_LIST_ERROR = `${url}/DELETE_EXPENSES_LIST_ERROR`;

export const LOAD_EXPENSES_LIST_RECORDS_META_DATA = `${url}/LOAD_EXPENSES_LIST_RECORDS_META_DATA`;
export const LOAD_EXPENSES_LIST_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_EXPENSES_LIST_RECORDS_META_DATA_SUCCESS`;
export const LOAD_EXPENSES_LIST_RECORDS_META_DATA_ERROR = `${url}/LOAD_EXPENSES_LIST_RECORDS_META_DATA_ERROR`;
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`;

const constants = {
  LOAD_EXPENSES_LIST,
  LOAD_EXPENSES_LIST_SUCCESS,
  LOAD_EXPENSES_LIST_ERROR,
  
  LOAD_PREFIX_SETTINGS_LIST,
  LOAD_PREFIX_SETTINGS_LIST_SUCCESS,
  LOAD_PREFIX_SETTINGS_LIST_ERROR,

  LOAD_FINANCIAL_YEAR_LIST,
  LOAD_FINANCIAL_YEAR_LIST_SUCCESS,
  LOAD_FINANCIAL_YEAR_LIST_ERROR,

  LOAD_EXPENSES_ITEMS_LIST,
  LOAD_EXPENSES_ITEMS_LIST_SUCCESS,
  LOAD_EXPENSES_ITEMS_LIST_ERROR,

  LOAD_EXPENSES_CATEGORIES_LIST,
  LOAD_EXPENSES_CATEGORIES_LIST_SUCCESS,
  LOAD_EXPENSES_CATEGORIES_LIST_ERROR,

  LOAD_EXPENSE_REPORT_LIST,
  LOAD_EXPENSE_REPORT_LIST_SUCCESS,
  LOAD_EXPENSE_REPORT_LIST_ERROR,
  
  LOAD_CASH_BANK_REPORT_LIST,
  LOAD_CASH_BANK_REPORT_LIST_SUCCESS,
  LOAD_CASH_BANK_REPORT_LIST_ERROR,


  CREATE_EXPENSES_LIST,
  CREATE_EXPENSES_LIST_SUCCESS,
  CREATE_EXPENSES_LIST_ERROR,

  UPDATE_EXPENSES_LIST,
  UPDATE_EXPENSES_LIST_SUCCESS,
  UPDATE_EXPENSES_LIST_ERROR,

  DELETE_EXPENSES_LIST,
  DELETE_EXPENSES_LIST_SUCCESS,
  DELETE_EXPENSES_LIST_ERROR,

  LOAD_RECORDS_VALID_CACHE,

  LOAD_EXPENSE_ACCOUNT_TRANSACTION_DETAILS,
  LOAD_EXPENSE_ACCOUNT_TRANSACTION_DETAILS_SUCCESS,
  LOAD_EXPENSE_ACCOUNT_TRANSACTION_DETAILS_ERROR,
  
  LOAD_CASH_BANK_TOTAL_LIST,
  LOAD_CASH_BANK_TOTAL_LIST_SUCCESS,
  LOAD_CASH_BANK_TOTAL_LIST_ERROR,

  LOAD_EXPENSES_LIST_RECORDS_META_DATA,
  LOAD_EXPENSES_LIST_RECORDS_META_DATA_SUCCESS,
  LOAD_EXPENSES_LIST_RECORDS_META_DATA_ERROR,
};

export default constants;
